<template>
    <validation-observer v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(submit)">
            <div class="required-info">
                 <div style="position: absolute">
                    <input style="left: -12000px;position:relative" name="password" type="password">
                 </div>

            <validation-provider name="avatar" rules="image" tag="div" class="m-b-10 avatar-wrappe" v-slot="{ validate, errors }">
                <div>
                    <input type="file" name="avatar" id="avatar" ref="file" @change="validate($event); handleFileUpload($event)" />
                    <label for="avatar" class="file-input-overlay" :style="{ backgroundImage: 'url(' + uploaded_image_url + ')' }">
                      <span class="avatar-edit">Edit</span></label>

                </div>
                <div class="col">
                    <p class="mb-0 mt-1 avatar-upload-feedback"> {{ errors[0] }}</p>
                </div>
            </validation-provider>
             <div class="row">
                    <div class="col-lg-6">
                        <validation-provider vid="first_name" name="First Name" rules="required|max:100" v-slot="{ errors }" tag="div" class="form-group">
                            <label for="first_name">First name:<span class="required">*</span></label>
                            <div class="input-wrapper">
                                <input type="text" id="first_name" v-model="model.first_name" placeholder="First Name" :class="{'is-invalid':errors.length}" class="form-control"  autocomplete="off">
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                 <div class="col-lg-6">
                        <validation-provider vid="last_name" name="Last Name" rules="max:100" v-slot="{ errors }" tag="div" class="form-group">
                            <label for="last_name">Last Name:</label>
                            <div class="input-wrapper">
                                <input type="text" id="last_name" v-model="model.last_name" placeholder="Last Name" :class="{'is-invalid':errors.length}" class="form-control"  autocomplete="off">
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <!-- End .col -->
                    <div class="col-lg-6">
                        <validation-provider name="email" rules="required|max:100|email" v-slot="{ errors }" tag="div" class="form-group">
                            <label for="email">Email:<span class="required">*</span></label>
                            <div class="input-wrapper">
                                <input type="text" id="email" v-model="model.email" placeholder="Email" :class="{'is-invalid':errors.length}" class="form-control"  autocomplete="off">
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <!-- End .col -->
                    <div class="col-md-6">
                        <validation-provider name="password" vid="password" rules="min:5|max:100"   v-slot="{ errors }" tag="div" class="form-group">
                            <label for="password">New Password:</label>
                            <div class="input-wrapper">
                                <input id="password" :type="password_field_type1" v-model="model.password" placeholder="New Password" class="form-control" :class="{'is-invalid':errors.length}" autocomplete="off">
                                <i class="far" :class="{'fa-eye-slash':password_field_type1=='password', 'fa-eye':password_field_type1=='text'}" @click="togglePasswordEye1"></i>
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                    <!-- End col -->
                    <div class="col-md-6">
                        <validation-provider name="password_confirmation" rules="password_confirmation:@password" v-slot="{ errors }" tag="div" class="form-group">
                            <label for="password_confirmation">Confirm New Password:</label>
                            <div class="input-wrapper">
                                <input :type="password_field_type2" class="form-control" id="password_confirmation" v-model="model.password_confirmation" placeholder="Confirm New Password" :class="{'is-invalid':errors.length}" autocomplete="off">
                                <i class="far" :class="{'fa-eye-slash':password_field_type2=='password', 'fa-eye':password_field_type2=='text'}" @click="togglePasswordEye2"></i>
                                <div class="invalid-feedback">{{ errors[0] }}</div>
                            </div>
                        </validation-provider>
                    </div>
                </div>
                <button type="submit" class="primary-btn mx-auto">Update Changes</button>
        </div>
            <div class="d-none">
                <input name="email" type="email"/>
            </div>
    </form>
    </validation-observer>
</template>


<script>
    const Swal = require('sweetalert2')
    export default {
        props: {
            fetchUrl: { type: String, required: true },
            postUrl: { type: String, required: true }
        },
        data() {
            return {
                model:{},
                fetch_url:'',
                post_url:'',
                avatar:null,
                avatar_url:'',
                error_message: false,
                is_submitted: false,
                uploaded_image_url:'',
                password_field_type1:'password',
                password_field_type2:'password'
            }
        },
        watch: {
            fetchUrl: {
                handler: function(fetchUrl) {
                    this.fetch_url = fetchUrl
                },
                immediate: true
            },
            postUrl: {
                handler: function(fetchUrl) {
                    this.post_url = fetchUrl
                },
                immediate: true
            },
        },
        created() {
            this.fetchData();
        },
        methods: {
            fetchData:function() {
                axios.get(this.fetch_url).then(({ data }) => {
                    this.model = data.model;
                    this.uploaded_image_url = this.model.avatar_url;

                }).catch(error => this.$throwSwalError(error))
            },

            handleFileUpload() {
                this.avatar = this.$refs.file.files[0];
                this.uploaded_image_url = URL.createObjectURL(this.avatar);
                $('#header-avatar-img').attr('src',this.uploaded_image_url);
            },
            submit: function (e) {
                var formData = new FormData();
                var modelObj = Object.keys(this.model);
                modelObj.map(fieldName => {
                    let value = this.model[fieldName];
                    formData.append(fieldName, value);
                });
                if (this.avatar) {
                    formData.append("new_avatar", this.avatar);
                }
                this.is_submitted = true;
                axios.post(this.post_url, formData)
                    .then(response => {
                        this.is_submitted = false;
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Your account has been updated',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }).catch(error => {
                        console.log(error)
                    this.is_submitted = false;
                    if(error.response.status == 422){
                        this.error_message = error.response.data.message;
                        this.$refs.form.setErrors(error.response.data.errors);
                    }else{
                        this.$throwSwalError(error);
                        this.error_message = "Something wrong at form!";
                    }
                });
            },
            togglePasswordEye1:function(e){
                if(this.password_field_type1=='password'){
                    this.password_field_type1 = 'text'
                }else{
                    this.password_field_type1 = 'password'
                }
            },
            togglePasswordEye2:function(e){
                if(this.password_field_type2=='password'){
                    this.password_field_type2 = 'text'
                }else{
                    this.password_field_type2 = 'password'
                }
            },
        }
    }
</script>
